import { useRef } from 'react';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
} from '@frontend/legacy-components';

export type DxfMappingAlertDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DxfMappingAlertDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: DxfMappingAlertDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>Discard role changes?</AlertDialogHeader>
        <AlertDialogBody>
          Your role edits haven&apos;t been saved. Leaving mapping mode now will
          discard them.
        </AlertDialogBody>
        <AlertDialogFooter>
          <ButtonGroup>
            <Button variant="secondary" ref={cancelRef} onClick={onClose}>
              Keep Editing
            </Button>
            <Button
              variant="primary"
              colorScheme="destructive"
              onClick={onConfirm}
            >
              Discard Changes
            </Button>
          </ButtonGroup>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
DxfMappingAlertDialog.displayName = 'DxfMappingAlertDialog';
